/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

import { useEffect, useState } from "react";

import Author from "components/Table/Author";
import MDBox from "components/MDBox";
import { IconButton } from "@mui/material";
import { Icons, defaultData } from "utils/Constants";
import moment from "moment";

const loanTypeTitle = {
  credit: "Credit Card",
  loanAgainstProperty: "Loan Against Property",
  loanAgainstSecurity: "Loan Against Security",
  workingCapital: "Working Capital",
  machinery: "Machinery Loan",
  gold: "Gold Loan",
};

const getLoanTypeTitle = (type) => loanTypeTitle[type] || `${type} Loan`;

export const currentStatusStyles = {
  "Document Verification": { backgroundColor: "#E1EFFE", color: "#1656E1" },
  "Application Submitted": { backgroundColor: "#F1E7FE", color: "#7430CA" },
  "Pending with Credit": { backgroundColor: "#F1E7FE", color: "#7430CA" },
  "Offer Received": { backgroundColor: "#F1E7FE", color: "#7430CA" },
  "Offer Selected": { backgroundColor: "#FEF5CD", color: "#DA850A" },
  "Loan Sanctioned": { backgroundColor: "#FEF5CD", color: "#DA850A" },
  "Disbursement Documentation": { backgroundColor: "#FEF5CD", color: "#DA850A" },
  Disbursement: { backgroundColor: "#DBF4DB", color: "#28873C" },
  "Amount Credited/Cheque issued": { backgroundColor: "#DBF4DB", color: "#28873C" },
  "Card Approved": { backgroundColor: "#FEF5CD", color: "#DA850A" },
  "Card Delivered": { backgroundColor: "#DBF4DB", color: "#28873C" },
  "Rejected By Bank": { backgroundColor: "#FEE4E2", color: "#D92D20" },
  "Denied By Customer": { backgroundColor: "#FEE4E2", color: "#D92D20" },
  default: { backgroundColor: "#F2F4F7", color: "#344054" },
};

const renderCurrentStatus = (status) => {
  const statusStyle = currentStatusStyles[status] || currentStatusStyles.default;

  return (
    <MDBox
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        minHeight: 24,
        maxWidth: 180,
        px: 1.25,
        py: 0.25,
        borderRadius: "6px",
        fontSize: 12,
        fontWeight: 600,
        lineHeight: 1.4,
        whiteSpace: "normal",
        ...statusStyle,
      }}
    >
      {status || "-"}
    </MDBox>
  );
};

const formatDateValue = (date1, date2) => {
  const targetDate = date1 || date2;
  if (!targetDate) return "-";
  return moment(targetDate).format(defaultData.WEB_DATE_FORMAT);
};

export default function data(
  loanData,
  handleEditModal,
  handleBasicEditModal,
  handleFetchCibil,
  handleDelete,
  isAdmin = true
) {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (loanData) {
      const list = loanData.map((item, index) => {
        const profileTypeMap = {
          self_employed: "Self Employed",
          salaried: "Salaried",
        };
        const profileTypeTitle = profileTypeMap[item?.profileType] || "";

        const temp = {
          srNo: <Author name={index + 1} />,
          leadDate: <Author name={formatDateValue(item?.leadDate, item?.createdAt)} />,
          loginDate: <Author name={formatDateValue(item?.loginDate, item?.dateOfLogin)} />,
          Date: <Author name={moment(item?.createdAt).format(defaultData.WEB_DATE_FORMAT)} />,
          type: <Author name={getLoanTypeTitle(item.type)} />,
          fileNumber: <Author name={item?.fileNumber} />,
          profileType: <Author name={profileTypeTitle} />,
          salesManager: <Author name={item?.salesManager?.sm || item?.salesManager} />,
          name: <Author name={`${item.firstName} ${item.lastName}`} />,
          email: <Author name={item.email} style={{ textTransform: "normal" }} />,
          phone: <Author name={item.mobileNumber} />,
          pinCode: <Author name={item.pinCode} />,
          loanAmount: (
            <Author
              name={
                item.loanAmount
                  ? Number(item.loanAmount.toString().replace(/,/g, "")).toLocaleString("en-IN")
                  : ""
              }
              align="right"
              style={{ textAlign: "right" }}
            />
          ),
          status: <Author name={item?.status} />,
          currentStatus: renderCurrentStatus(item?.currentStatus),
          cardDeliveryDate: (
            <Author
              name={
                item?.cardDeliveryDate
                  ? moment(item.cardDeliveryDate).format(defaultData.WEB_DATE_FORMAT)
                  : "-"
              }
            />
          ),
          lastUpdate: <Author name={moment(item?.updatedAt).format(defaultData.WEB_DATE_FORMAT)} />,
          sourceOfLead: <Author name={item?.sourceOfLead} />,
          imd: <Author name={item?.imd} />,
          refBy: <Author name={item?.refBy} />,
          bank: item?.bank?.bankLogo ? (
            <MDBox
              component="img"
              src={item.bank.bankLogo}
              alt={item?.bank?.bankName || "Bank"}
              title={item?.bank?.bankName}
              sx={{ width: 96, height: 36, objectFit: "contain", display: "block" }}
            />
          ) : (
            <Author name={item?.bank?.bankName} />
          ),
          code: <Author name={item?.code?.code} />,
          cibil: (
            <MDBox>
              <IconButton
                fontSize="medium"
                sx={{ cursor: "pointer", color: "#475467" }}
                onClick={() => handleFetchCibil(item)}
              >
                {Icons.VIEW}
              </IconButton>
            </MDBox>
          ),
          action: (
            <MDBox>
              <IconButton
                fontSize="medium"
                sx={{ cursor: "pointer", color: "#475467" }}
                onClick={() => handleBasicEditModal(item)}
              >
                {Icons.NOTE_EDIT}
              </IconButton>
              <IconButton
                fontSize="medium"
                sx={{ cursor: "pointer", color: "#475467" }}
                onClick={() => handleEditModal(item)}
              >
                {Icons.EDIT2}
              </IconButton>
              {isAdmin && (
                <IconButton
                  fontSize="medium"
                  sx={{ cursor: "pointer", color: "#475467" }}
                  onClick={() => handleDelete(item)}
                >
                  {Icons.DELETE}
                </IconButton>
              )}
            </MDBox>
          ),
        };
        return temp;
      });
      setRows([...list]);
    }
  }, [loanData, isAdmin]);

  return {
    columns: [
      { Header: "No.", accessor: "srNo", width: "3%" },
      { Header: "Lead Date", accessor: "leadDate", width: "10%" },
      { Header: "Login Date", accessor: "loginDate", width: "10%" },
      { Header: "Created Date", accessor: "Date", width: "10%" },
      { Header: "Product", accessor: "type", width: "10%" },
      { Header: "Loan File", accessor: "fileNumber", width: "10%" },
      { Header: "Profile Type", accessor: "profileType", width: "10%" },
      { Header: "Sales Manager", accessor: "salesManager", width: "10%" },
      { Header: "Name", accessor: "name", width: "10%" },
      { Header: "Email", accessor: "email", width: "10%" },
      { Header: "Mobile Number", accessor: "phone", width: "10%" },
      { Header: "Pin code", accessor: "pinCode", width: "10%" },
      { Header: "Loan Amount", accessor: "loanAmount", width: "10%", align: "right" },
      { Header: "Status", accessor: "status", width: "10%" },
      { Header: "Current Status", accessor: "currentStatus", width: "10%" },
      { Header: "Delivery Date", accessor: "cardDeliveryDate", width: "10%" },
      { Header: "Last update date", accessor: "lastUpdate", width: "10%" },
      { Header: "Source of Lead", accessor: "sourceOfLead", width: "10%" },
      { Header: "IMD", accessor: "imd", width: "10%" },
      { Header: "Ref By", accessor: "refBy", width: "10%" },
      { Header: "Bank", accessor: "bank", width: "10%" },
      { Header: "Code", accessor: "code", width: "10%" },
      { Header: "Cibil", accessor: "cibil", width: "10%" },
      { Header: "Action", accessor: "action", width: "10%" },
    ],
    rows,
  };
}
